import { IYearMonth } from '@/coreDomainsModule/date';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { SupplierForecastRepository } from '@/coreInfrastructureModule/Repositories/SupplierForecastRepository';
import { ISupplierForecastExportDataResult } from '../domains/entities/supplierForecastExportData';
import { SupplierForecastExportDataAdapter } from '../adapter/supplierForecastExportDataAdapter';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';

/**
 * 仕入先内示のダウンロードに必要なデータを取得するユースケース
 */
export class BulkGetSupplierForecastExportData {
  /**
   * 仕入先内示のダウンロードに必要なデータを取得する
   * @param repository - リポジトリ
   * @param targetStartYearMonth - 対象開始年
   * @param targetEndYearMonth - 対象終了年
   * @param filterItems - フィルター項目
   */
  public async Execute(
    repository: SupplierForecastRepository,
    targetStartYearMonth: IYearMonth,
    targetEndYearMonth: IYearMonth,
    filterItems?: FilterContentItem[]
  ): Promise<INetworkResult<ISupplierForecastExportDataResult, IError>> {
    const response = await repository.bulkGetExportData(
      targetStartYearMonth.year,
      targetStartYearMonth.month,
      targetEndYearMonth.year,
      targetEndYearMonth.month,
      filterItems !== undefined && filterItems.length > 0 ? FilterService.convertFilterObject(filterItems) : undefined
    );
    switch (response.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: await SupplierForecastExportDataAdapter.adaptForResponse(response.status.data, targetStartYearMonth, targetEndYearMonth),
          },
        };
      case 'error':
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
    }
  }
}
